// const displayOutsideTownshipText = (v) => {
//   if(v == 2) return 'No'
//   if(v == 1) return 'Yes'
//   return ''
// }

// Helper function to escape values starting with = to prevent Excel from treating them as formulas
function escapeFormula(value) {
    if (value == null || value === undefined) return value;
    const str = String(value);
    // If value starts with =, prefix with tab character
    if (str.trim().startsWith('=')) {
        return '\t' + str;
    }
    return str;
}

export function getCustomFields(v) {
    let newObj = {
        Date: escapeFormula(v.date),
        "Code": Number(v.mdrtb_code),
        "Year": Number(v.mdrtb_year),
        "Mono-Poly":v.patient?(parseInt(v.patient.mdrtb_monopoly) == 2 ? "Yes" : parseInt(v.patient.mdrtb_monopoly) == 3 ? "SG" : parseInt(v.patient.mdrtb_monopoly) == 4 ? "MGY" : 'No'):'',
        Township: escapeFormula(String(v.township.name)),
        Township_Code: escapeFormula(String(v.township.short_code)),
        "Township Group ": parseInt(v.township.township_group_id) == 1 ? "MDR 1 " : parseInt(v.township.township_group_id) == 2 ? "MDR 2" : '',
        Type: v.type == 2 ? "By Phone" : "By Person",
        "Outside Township": v.outside_township == 2 ? "Yes" : v.outside_township == 1 ? "No" : '',
        "No of patient live in same household": v.lived_patients_no,
    };

    return newObj;
}

